export type LineLogisticsOverrides = {
  scheduled_date_override?: string | null;
  warmup_time_override?: string | null;
  start_time_override?: string | null;
  facility_id_override?: string | null;
  location_text_override?: string | null;
  court_assignment?: string | null;
  logistics_changed_after_publish?: boolean | null;
};

export type ParentMatchLogistics = {
  match_date?: string | null;
  warmup_time?: string | null;
  match_time?: string | null;
  facility_id?: string | null;
  location_text?: string | null;
  court_numbers?: string | null;
};

export type EffectiveLineLogistics = {
  date: string | null;
  warmupTime: string | null;
  startTime: string | null;
  facilityId: string | null;
  locationText: string | null;
  courtAssignment: string | null;
  hasOverride: boolean;
  hasMaterialScheduleOverride: boolean;
  wasRescheduled: boolean;
};

const clean = (value: string | null | undefined) => value?.trim() || null;

export function effectiveLineLogistics(parent: ParentMatchLogistics, override?: LineLogisticsOverrides | null): EffectiveLineLogistics {
  const dateOverride = clean(override?.scheduled_date_override);
  const warmupOverride = clean(override?.warmup_time_override);
  const timeOverride = clean(override?.start_time_override);
  const facilityOverride = clean(override?.facility_id_override);
  const locationOverride = clean(override?.location_text_override);
  const court = clean(override?.court_assignment) || clean(parent.court_numbers);
  const hasOverride = Boolean(dateOverride || warmupOverride || timeOverride || facilityOverride || locationOverride || clean(override?.court_assignment));
  return {
    date: dateOverride || clean(parent.match_date),
    warmupTime: warmupOverride || clean(parent.warmup_time),
    startTime: timeOverride || clean(parent.match_time),
    facilityId: facilityOverride || clean(parent.facility_id),
    locationText: locationOverride || clean(parent.location_text),
    courtAssignment: court,
    hasOverride,
    hasMaterialScheduleOverride: Boolean(dateOverride || warmupOverride || timeOverride),
    wasRescheduled: Boolean(override?.logistics_changed_after_publish),
  };
}

export function lineLogisticsDiffer(parent: ParentMatchLogistics, override?: LineLogisticsOverrides | null): boolean {
  return effectiveLineLogistics(parent, override).hasOverride;
}

export function matchHasSplitSchedule(overrides: Iterable<LineLogisticsOverrides | null | undefined>): boolean {
  return [...overrides].some((override) => effectiveLineLogistics({}).hasOverride || Boolean(
    clean(override?.scheduled_date_override) || clean(override?.warmup_time_override) || clean(override?.start_time_override) || clean(override?.facility_id_override) || clean(override?.location_text_override) || clean(override?.court_assignment),
  ));
}
